<template>
    <div
        id="lt-yantr"
        class="advanced-calc mortgage-payment-calc">
        <div class="container-width">
            <div class="advanced-calc-filter">
                <ul class="filter-inputs">
                    <li>
                        <number-input
                            v-model="HomePrice"
                            :label="labelHomePrice"
                            inputmode="decimal"
                            @input="updateHomeInsurance($event)"
                        />
                    </li>
                    <li>
                        <drop-down
                            v-model.number="LoanTermInYears"
                            :label="labelLoanTerm"
                            :options="LoanTermInYearsList"
                            :tooltip-link="LoanTypeTooltip"
                        />
                    </li>
                    <li class="percentage-amt">
                        <div>
                            <number-input
                                v-model="DownPayment"
                                :label="labelDownPayment"
                                :tooltip-link="DownPaymentTooltip"
                                inputmode="decimal"
                                @input="DownPaymentChange($event)"
                            />
                        </div>
                    </li>
                    <li class="percentage-input">
                        <number-input
                            v-model="DownPaymentPercent"
                            symbol="%"
                            symbol-aligned="right"
                            max-value="100.00"
                            inputmode="decimal"
                            precision="2"
                            @input="DownPaymentPercentChange($event)"
                        />
                    </li>
                    <li>
                        <number-input
                            v-model="MortgageRate"
                            :label="labelMortgageRate"
                            symbol="%"
                            symbol-aligned="right"
                            precision="3"
                            max-value="100.000"
                            inputmode="decimal"
                            @input="restrictMortgageRateToMaxValue"
                        />
                    </li>
                </ul>
                <!-- Advanced Options start -->
                <div
                    v-show="ShowAdvancedOptions"
                    class="advanced-options"
                    :class="{ 'all-options': ShowAdvancedOptions, 'less-options' : !ShowAdvancedOptions}">
                    <ul class="filter-inputs">
                        <li class="mob-date-picker">
                            <div class="form-group">
                                <label>Start Date:</label>
                                <datepicker
                                    v-model="CurrentDate"
                                    format="MM/DD/YYYY"
                                    lang="en">
                                    <span slot="icon-calendar">
                                        <img
                                            alt="date picker icon"
                                            src="../../assets/images/date-picker.png"
                                        />
                                    </span>
                                </datepicker>
                            </div>
                        </li>
                        <li class="inputs-subtext">
                            <number-input
                                v-model="HomeInsurance"
                                :label="labelHomeInsurance"
                                inputmode="decimal"
                            />
                            <span class="subtext-val">/year</span>
                        </li>
                        <li class="hidden-xs">
                            <div class="form-group">
                                <label>Start Date:</label>
                                <datepicker
                                    v-model="CurrentDate"
                                    format="MM/DD/YYYY"
                                    lang="en">
                                    <span slot="icon-calendar">
                                        <img
                                            alt="date picker icon"
                                            src="../../assets/images/date-picker.png"
                                        />
                                    </span>
                                </datepicker>
                            </div>
                        </li>
                        <li class="percentage-amt inputs-subtext">
                            <number-input
                                v-model="PropertyTaxes"
                                :label="labelPropertyTaxes"
                                inputmode="decimal"
                                @input="PropertyTaxesChange($event)"
                            />
                            <span class="subtext-val">/year</span>
                        </li>
                        <li class="percentage-input">
                            <number-input
                                v-model="PropertyTaxesPercent"
                                symbol="%"
                                symbol-aligned="right"
                                max-value="100.00"
                                precision="2"
                                inputmode="decimal"
                                @input="PropertyTaxesPercentChange($event)"
                            />
                        </li>
                        <li class="inputs-subtext">
                            <number-input
                                v-model="HoaFees"
                                :label="labelHoaFees"
                                inputmode="decimal"
                                maxlength="6"
                            />
                            <span class="subtext-val">/month</span>
                        </li>
                        <li class="include-pmi">
                            <div class="form-checkbox">
                                <input
                                    id="includePMI"
                                    v-model="IsPmiInclude"
                                    type="checkbox"
                                    :disabled="!CheckPMI"
                                />
                                <label for="includePMI"> Include PMI</label>
                                <lt-label
                                    :span="span"
                                    :tooltip-link="PrivateMortgageInsuranceTooltip"
                                />
                            </div>
                        </li>
                    </ul>
                </div>
                <a
                    v-show="ShowAdvancedOptions"
                    href="javascript:void(0)"
                    class="reset-calc hidden-xs"
                    @click="resetFilter()">
                    <span class="lt-icons lt4-Refresh"></span>
                    &#32;Reset Calculator
                </a>
                <!-- Advanced Options end-->
                <button
                    v-show="ShowAdvancedOptions"
                    class="btn btn-blue recalculate"
                    type="submit"
                    @click="calculateAndViewMore()">
                    {{ recalculateButtonText }}
                </button>
                <label
                    class="show-hide-options"
                    :class="{ 'hidden-xs': ShowAdvancedOptions}"
                    @click="viewMoreClick()">
                    <span
                        class="lt-icons"
                        :class="{ 'lt4-MinusCircle': ShowAdvancedOptions, 'lt4-PlusCircle' : !ShowAdvancedOptions}"></span>
                    {{ !ShowAdvancedOptions ? "" : "Hide" }} Advanced Options
                </label>
            </div>
            <div class="row calculation-section">
                <div class="col-xs-12 col-sm-7 left-section">
                    <h4>Your {{ PaymentFrequency }} payment will be:</h4>
                    <label
                        class="homeprice"
                        :class="{ 'red-text': isNegativeAmount}">${{
                        currencyFilterWithPrecision(TotalMoPayment)
                    }}</label>
                    <ul
                        v-if="allTotalPaymentSection===1"
                        class="calc-box calc-box-result">
                        <li>
                            <label>Total<span class="hidden-xs"> Loan</span>  Amount:
                                <lt-label
                                    :span="span"
                                    :tooltip-link="TotalLoanAmountTooltip"
                                />
                            </label>
                            <h3 class="value">
                                ${{ currencyFilterWithPrecision(totalLoanAmount) }}
                            </h3>
                        </li>
                        <li>
                            <label>Total Interest Paid:
                                <lt-label
                                    :span="span"
                                    :tooltip-link="TotalInterestTooltip"
                                />
                            </label>
                            <h3 class="value">
                                ${{ currencyFilterWithPrecision(AllTotalInterest) }}
                            </h3>
                        </li>
                        <li>
                            <label>Total Of All Payments:
                                <lt-label
                                    :span="span"
                                    :tooltip-link="TotalOfAllPaymentTooltip"
                                />
                            </label>
                            <h3 class="value">
                                ${{
                                    currencyFilterWithPrecision(totalLoanAmount + AllTotalInterest)
                                }}
                            </h3>
                        </li>
                    </ul>
                    <div class="view-free-offers">
                        <h4>We’ve found offers for this result:</h4>
                        <button
                            class="btn btn-darkblue"
                            type="submit"
                            @click="redirect()">
                            {{
                                DestinationButtonText
                            }}
                        </button>
                    </div>
                    <div>
                        <advertising-disclosures
                            v-if="DisclosureText"
                            :disclosure-text="DisclosureText"
                            :disclosure-tokens="DisclosureTokens"
                        />
                    </div>
                    <lt-logo v-if="ltLogo===1">
                        <small>NMLS#1136 Terms & Conditions Apply</small>
                    </lt-logo>
                </div>
                <div class="col-xs-12 col-sm-5 right-section text-center">
                    <h4>{{ capitalize(PaymentFrequency) }} payment breakdown</h4>
                    <div class="chart-parent">
                        <vue-chart
                            type="doughnut"
                            :data="chartData"
                            :options="options"
                            :width="chartWidth"
                            :height="chartHeight"
                        />
                        <div class="donut-inner">
                            <label>Total {{ PaymentFrequency }} Payment:</label>
                            <h3 :class="{ 'red-text': isNegativeAmount}">
                                ${{ currencyFilterWithPrecision(TotalMoPayment) }}
                            </h3>
                        </div>
                    </div>
                    <div class="monthly-budget">
                        <ul class="list-unstyled summary">
                            <li>
                                <label><span class="green-bg"></span> Principal & Interest:</label>
                                <span
                                    class="value"
                                    :class="{ 'red-text': isNegativeAmount}">${{
                                    currencyFilterWithPrecision(MoPrincipalIntestrest / Math.round(PayFreqInNumber / 12))
                                }}</span>
                            </li>
                            <li>
                                <label><span class="red-bg"></span> Property Taxes:</label>
                                <span class="value">${{
                                    currencyFilterWithPrecision(PropertyTaxesCurrency * 12 / PayFreqInNumber)
                                }}</span>
                            </li>
                            <li>
                                <label><span class="blue-bg"></span> Homeowners Insurance:</label>
                                <span class="value">${{
                                    currencyFilterWithPrecision(HomeInsuranceCurrency * 12 / PayFreqInNumber)
                                }}</span>
                            </li>
                            <li>
                                <label><span class="purple-bg"></span> HOA dues:</label>
                                <span class="value">${{
                                    currencyFilterWithPrecision(HoaFees * 12 / PayFreqInNumber)
                                }}</span>
                            </li>
                            <li>
                                <label><span class="orange-bg"></span> PMI:</label>
                                <span class="value">${{
                                    currencyFilterWithPrecision(PmiCurrency * 12 / PayFreqInNumber)
                                }}</span>
                            </li>
                        </ul>
                        <div class="clear-fix"></div>
                    </div>
                </div>
                <div
                    v-if="howToUseCalculator===1"
                    class="col-xs-12 about-calculator text-center">
                    <a
                        v-vue-scroll-to="{ el:'#how-to-use-mortgage-calculator', offset: -90 }"
                        class="btn btn-blue">
                        How to use this calculator
                    </a>
                </div>
            </div>
            <strategies-faster-payoff
                v-if="strategiesPayoffSection===1"
                :total-mo-payment="TotalMoPayment"
                :payment-frequency="PaymentFrequency"
                :all-total-principal="AllTotalPrincipal"
                :all-total-interest="AllTotalInterest"
                :all-total-extra-payments="AllTotalExtraPayments"
                :all-total-taxes-fees="AllTotalTaxesFees"
                :save-years="SaveYears"
                :save-months="SaveMonths"
                :save-interest="SaveInterest"
                :current-date="CurrentDate"
                :loan-term-in-years="LoanTermInYears"
                @getOverPayVal="getOverPayVal($event)"
                @getCashBombVal="getCashBombVal($event)"
                @getPaymentFrequency="getPaymentFrequency($event)"
                @getCashBombFrequency="getCashBombFrequency($event)"
                @getCashBombStartDate="getCashBombStartDate($event)"
            />
            <mortgage-payment-schedule
                v-if="mortgagePaymentSection===1"
                :loan-term-in-years="LoanTermInYears"
                :current-date="CurrentDate"
                :all-year-deatils-for-chart="AllYearDeatilsForChart"
                :payment-frequency="PaymentFrequency"
                @getPaymentFrequency="getPaymentFrequency($event)"
            />
            <mortgage-amortization-breakdown-table
                v-if="amortizationTableSection===1"
                :loan-amount="MortgageAmount"
                :loan-term-in-years="LoanTermInYears"
                :interest-rate="MortgageRate"
                :home-value="unformat(HomePrice)"
                :additional-monthly-expenses="calculateTaxesFees"
                :extra-payment="OverpaySliderVal"
                :include-pmi="IsPmiInclude ? 0 : 1"
                :start-date="CurrentDate"
                :payment-frequency="PaymentFrequency"
                :cash-bomb="CashBombSliderVal"
                :cash-bomb-frequency="CashBombFrequency"
                :cash-bomb-start-date="CashBombStartDate"
                :show-amortization-table="collapseAmortizationTableData !== 1"
                @UpdateTableCalculation="updateTableCalculation"
            />
        </div>
    </div>
</template>

<script>
    import Accounting from 'accounting';
    import VueChart from 'vue-chart-js';
    import VueScrollTo from 'vue-scrollto';
    import Datepicker from 'vue2-datepicker';
    import AdvertisingDisclosures from '~/components/advertising-disclosures.vue';
    import DropDown from '~/components/drop-down.vue';
    import LtLabel from '~/components/lt-label.vue';
    import LtLogo from '~/components/lt-logo.vue';
    import NumberInput from '~/components/number-input.vue';
    import LoanTermList from '~/constants/loan-term-list';
    import DefaultTooltip from '~/constants/tooltip-defaults';
    import ChartTooltip from '~/helpers/chart-tooltip';
    import PaymentHelper from '~/helpers/payment';
    import BaseMixin from '~/mixin/base-mixin';
    import MortgageAmortizationBreakdownTable from './components/mortgage-amortization-breakdown-table.vue';
    import MortgagePaymentSchedule from './components/mortgage-payment-schedule.vue';
    import StrategiesFasterPayoff from './components/strategies-faster-payoff.vue';

    export default {
        components: {
            NumberInput,
            DropDown,
            LtLabel,
            VueChart,
            StrategiesFasterPayoff,
            MortgagePaymentSchedule,
            Datepicker,
            MortgageAmortizationBreakdownTable,
            LtLogo,
            AdvertisingDisclosures,
        },
        directives: {
            VueScrollTo,
        },
        mixins: [BaseMixin],
        props: {
            labelHomePrice: {
                default: 'Home Price:',
            },
            labelDownPayment: {
                default: 'Down Payment:',
            },
            labelLoanTerm: {
                default: 'Loan Term:',
            },
            labelMortgageRate: {
                default: 'Mortgage Rate:',
            },
            labelPropertyTaxes: {
                default: 'Property Taxes:',
            },
            labelHomeInsurance: {
                default: 'Home Insurance:',
            },
            labelHoaFees: {
                default: 'HOA Fees:',
            },
            homePrice: {
                default: '350000',
            },
            downPayment: {
                default: '70000',
            },
            mortgageRate: {
                default: '3.630',
            },
            propertyTaxes: {
                default: '1.25',
            },
            homeInsurance: {
                default: '1225',
            },
            hoaFees: {
                default: '50',
            },
            creditScore: {
                default: '2',
            },
            loanTermInYears: {
                default: 30,
            },
            propertyTaxesPercent: {
                default: 1.25,
            },
            downPaymentTooltip: {
                default: DefaultTooltip.DownPayment,
            },
            loanTypeTooltip: {
                default: DefaultTooltip.LoanType,
            },
            privateMortgageInsuranceTooltip: {
                default: DefaultTooltip.PrivateMortgageInsurance,
            },
            totalInterestTooltip: {
                default: DefaultTooltip.TotalInterest,
            },
            totalLoanAmountTooltip: {
                default: DefaultTooltip.TotalLoanAmount,
            },
            totalOfAllPaymentTooltip: {
                default: DefaultTooltip.TotalOfAllPayment,
            },
            showAdvancedOptions: {
                default: false,
            },
            span: {
                type: String,
                default: '',
            },
            recalculateButtonText: {
                default: 'Recalculate',
            },
            checkPMI: {
                default: false,
            },
            pmiPerc: {
                default: '0.00625',
            },
            moExtraPayment: {
                default: '0',
            },
            totalMoPayment: {
                default: '2083',
            },
            homeInsurancePerc: {
                default: '0.35',
            },
            ltLogo: {
                default: 0,
            },
            disclosureTokens: {
                default: '01',
            },
            disclosureText: {
                default: 'Disclosures',
            },
            strategiesPayoffSection: {
                default: 1,
            },
            mortgagePaymentSection: {
                default: 1,
            },
            amortizationTableSection: {
                default: 1,
            },
            collapseAmortizationTableData: {
                default: 1,
            },
            allTotalPaymentSection: {
                default: 1,
            },
            howToUseCalculator: {
                default: 1,
            },
            destinationLinkOrId: {
                default: 'wp-mortgage',
            },
            destinationButtonText: {
                default: 'View Free Offers',
            },
            downpaymentPercent: {
                default: 20.00,
            },
            maxValue: {
                default: 999999999,
            },
            mortgageRateFifteen: {
                default: 5.7,
            },
            mortgageRateThirty: {
                default: 6.4,
            },
        },
        data() {
            return {
                HomePrice: this.homePrice,
                DownPayment: this.downPayment,
                MortgageRate: parseFloat(this.mortgageRate),
                PropertyTaxes: parseFloat(this.propertyTaxes),
                HomeInsurance: this.homeInsurance,
                HoaFees: parseInt(this.hoaFees, 10),
                LoanTermInYears: parseInt(this.loanTermInYears, 10),
                LoanTermInYearsList: LoanTermList.LoanTermInYearsList.refinance,
                DownPaymentTooltip: parseInt(this.hideTooltip, 10) ? '' : this.downPaymentTooltip,
                LoanTypeTooltip: parseInt(this.hideTooltip, 10) ? '' : this.loanTypeTooltip,
                PrivateMortgageInsuranceTooltip: parseInt(this.hideTooltip, 10) ? '' : this.privateMortgageInsuranceTooltip,
                TotalInterestTooltip: parseInt(this.hideTooltip, 10) ? '' : this.totalInterestTooltip,
                TotalLoanAmountTooltip: parseInt(this.hideTooltip, 10) ? '' : this.totalLoanAmountTooltip,
                TotalOfAllPaymentTooltip: parseInt(this.hideTooltip, 10) ? '' : this.totalOfAllPaymentTooltip,
                ShowAdvancedOptions: this.showAdvancedOptions,
                DownPaymentPercent: Accounting.formatNumber(this.downpaymentPercent, { precision: 2 }),
                PropertyTaxesPercent: this.propertyTaxesPercent,
                CheckPMI: this.checkPMI,
                IsPmiInclude: this.checkPMI,
                PmiPerc: parseFloat(this.pmiPerc),
                MoPrincipalIntestrest: this.moPrincipalIntestrest,
                PropertyTaxesCurrency: 0,
                HomeInsuranceCurrency: 0,
                PmiCurrency: 0,
                TotalMoPayment: this.totalMoPayment,
                MoExtraPayment: parseInt(this.moExtraPayment, 10),
                CreditScore: this.creditScore,
                HomeInsurancePerc: parseFloat(this.homeInsurancePerc),
                MonthlyInterestRatePerc: 0,
                MortgageAmount: 0,
                DownPaymentExpenses: 0,
                PmiAmount: 0,
                DisclosureText: this.disclosureText,
                DisclosureTokens: this.disclosureTokens,
                DestinationLinkOrId: this.destinationLinkOrId,
                DestinationButtonText: this.destinationButtonText,
                MortgageRateThirty: this.mortgageRateThirty,
                MortgageRateFifteen: this.mortgageRateFifteen,
                // Setting for chart
                chartData: {
                    labels: [],
                    datasets: [
                        {
                            data: [],
                            backgroundColor: [
                                '#08c177',
                                '#da3551',
                                '#00aeef',
                                '#2087c1',
                                '#ff704d',
                                '#d60000',
                            ],
                            borderWidth: 0,
                        },
                    ],
                },
                options: {
                    cutoutPercentage: 89,
                    legend: {
                        display: false,
                    },
                    tooltips: {
                        enabled: false,
                        custom: ChartTooltip.customTooltips,
                    },
                },
                chartWidth: 200,
                chartHeight: 130,
                CurrentDate: new Date(),
                OverpaySliderVal: 0,
                CashBombSliderVal: 0,
                AllTotalPrincipal: 0,
                AllTotalInterest: 0,
                AllTotalTaxesFees: 0,
                AllTotalExtraPayments: 0,
                AllYearDeatilsForChart: {},
                PaymentFrequency: 'monthly',
                CashBombFrequency: '',
                CashBombStartDate: '',
                SaveYears: 0,
                SaveMonths: 0,
                SaveInterest: 0,
            };
        },
        computed: {
            isNegativeAmount() {
                return this.TotalMoPayment < 0;
            },
            calculateTaxesFees() {
                return this.PropertyTaxesCurrency + this.HomeInsuranceCurrency + parseFloat(this.HoaFees);
            },
            totalLoanAmount() {
                return this.unformat(this.HomePrice) - this.unformat(this.DownPayment);
            },
            PayFreqInNumber() {
                switch (this.PaymentFrequency) {
                    case 'weekly':
                        return 52;
                    case 'bi-weekly':
                        return 26;
                    default:
                        return 12;
                }
            },
        },
        watch: {
            HomePrice() {
                this.calculatePayment();
            },
            DownPayment() {
                this.calculatePayment();
            },
            CreditScore() {
                this.calculatePayment();
            },
            CurrentDate() {
                this.calculatePayment();
            },
            LoanTermInYears() {
                this.calculatePayment();
            },
            MortgageRate() {
                this.calculatePayment();
            },
            PropertyTaxes() {
                this.calculatePayment();
            },
            HomeInsurance() {
                this.calculatePayment();
            },
            HoaFees() {
                this.calculatePayment();
            },
            IsPmiInclude() {
                this.calculatePayment();
            },
            MoExtraPayment() {
                this.calculatePayment();
            },
            PaymentFrequency() {
                this.calculatePayment();
            },
            CheckPMI(newValue) {
                if (newValue) {
                    this.IsPmiInclude = true;
                }
            },
        },
        mounted() {
            this.InitializeData();
            this.PaymentFrequency = 'monthly';
            this.updateMortgageRate();
        },
        methods: {
            restrictMortgageRateToMaxValue() {
                this.MortgageRate = this.unformat(this.MortgageRate) > 100 ? 100.000 : this.MortgageRate;
            },
            unformat(val) {
                return Accounting.unformat(val);
            },
            calculateAndViewMore() {
                this.calculatePayment();
                this.viewMoreClick();
            },
            viewMoreClick() {
                this.ShowAdvancedOptions = !this.ShowAdvancedOptions;
            },
            calculatePayment() {
                const payFreq = this.PayFreqInNumber;
                this.interestRate = this.MortgageRate;
                this.MortgageAmount = this.unformat(this.HomePrice) - this.unformat(this.HomePrice) * (this.unformat(this.DownPayment) / this.unformat(this.HomePrice) * 100 / 100);
                this.DownPaymentExpenses = parseFloat(this.unformat(this.DownPayment));
                this.MonthlyInterestRatePerc = this.interestRate / 1200;
                this.propertyTaxesPerYear = this.unformat(this.HomePrice) * (this.unformat(this.PropertyTaxesPercent) / 100);
                this.PmiPerc = this.IsPmiInclude ? parseFloat(this.pmiPerc) : 0;
                this.PmiAmount = this.MortgageAmount * this.PmiPerc;
                this.AmortizationPeriodInMonths = this.LoanTermInYears * 12;
                this.MoPrincipalIntestrest = PaymentHelper.getMonthlyPrincipalAndIntreset(this.MortgageAmount, this.AmortizationPeriodInMonths, this.MonthlyInterestRatePerc);
                this.PropertyTaxesCurrency = this.propertyTaxesPerYear / 12;
                this.HomeInsuranceCurrency = this.unformat(this.HomeInsurance) / 12;
                this.PmiCurrency = this.PmiAmount / 12;
                this.TotalMoPayment = this.MoPrincipalIntestrest / Math.round(payFreq / 12)
                    + this.MoExtraPayment
                    + this.PropertyTaxesCurrency * 12 / payFreq
                    + this.HomeInsuranceCurrency * 12 / payFreq
                    + this.PmiCurrency * 12 / payFreq
                    + this.HoaFees * 12 / payFreq;
                /* Monthly payment breakdown doughnut chart */
                this.chartData.labels = [];
                this.chartData.datasets[0].data = [];
                this.chartData.labels.push(`Principal & Interest ${Accounting.formatMoney(this.MoPrincipalIntestrest, { precision: 2 })}`);
                this.chartData.labels.push(`Property Taxes ${Accounting.formatMoney(this.PropertyTaxesCurrency, { precision: 2 })}`);
                this.chartData.labels.push(`Homeowners Insurance ${Accounting.formatMoney(this.HomeInsuranceCurrency, { precision: 2 })}`);
                this.chartData.labels.push(`HOA dues ${Accounting.formatMoney(this.HoaFees, { precision: 2 })}`);
                this.chartData.labels.push(`PMI ${Accounting.formatMoney(this.PmiCurrency, { precision: 2 })}`);
                const paymentPercent = Math.round(Math.abs(this.MoPrincipalIntestrest / this.TotalMoPayment * 100));
                const porpertyTxPercent = Math.round(Math.abs(this.PropertyTaxesCurrency / this.TotalMoPayment * 100));
                const insurancePercent = Math.round(Math.abs(this.HomeInsuranceCurrency / this.TotalMoPayment * 100));
                const hoaPercent = Math.round(Math.abs(this.HoaFees / this.TotalMoPayment * 100));
                const pmiPercent = Math.round(Math.abs(this.PmiCurrency / this.TotalMoPayment * 100));
                const moExtraPercent = Math.round(Math.abs(this.MoExtraPayment / this.TotalMoPayment * 100));

                this.chartData.datasets[0].data.push(paymentPercent);
                this.chartData.datasets[0].data.push(porpertyTxPercent);
                this.chartData.datasets[0].data.push(insurancePercent);
                this.chartData.datasets[0].data.push(hoaPercent);
                this.chartData.datasets[0].data.push(pmiPercent);
                this.chartData.datasets[0].data.push(moExtraPercent);

                this.CheckPMI = this.DownPaymentPercent < 20;

                if (!this.CheckPMI) {
                    this.IsPmiInclude = false;
                }
            },
            updateInitialInterestRate(val) {
                this.MortgageRate = val;
                this.calculatePayment();
            },
            currencyFilter(figure) {
                return Accounting.formatNumber(Math.abs(figure));
            },
            resetFilter() {
                this.HomePrice = Accounting.formatNumber(this.homePrice, { precision: 0 });
                this.DownPayment = Accounting.formatNumber(this.downPayment);
                this.DownPaymentChange(this.DownPayment);
                this.LoanTermInYears = parseInt(this.loanTermInYears, 10);
                this.MortgageRate = Accounting.formatNumber(this.mortgageRate, { precision: 3 });
                this.PropertyTaxes = Accounting.formatNumber(this.getDollarAmount(this.propertyTaxes));
                this.PropertyTaxesPercent = Accounting.formatNumber(this.propertyTaxesPercent, { precision: 2 });
                this.HomeInsurance = Accounting.formatNumber(this.homeInsurance);
                this.HoaFees = parseInt(this.hoaFees, 10);
                this.CreditScore = this.creditScore;
                this.IsPmiInclude = this.downpaymentPercent < 20;
                this.CheckPMI = this.downpaymentPercent < 20;
                this.CurrentDate = new Date();
                this.updateMortgageRate();
            },
            updateMortgageRate() {
                this.MortgageRate = this.LoanTermInYears === 30 ? this.MortgageRateThirty : this.MortgageRateFifteen;
            },
            updateHomeInsurance(val) {
                if (this.unformat(val) > this.unformat(this.maxValue)) {
                    this.HomePrice = this.maxValue;
                }
                this.InitializeData();
            },
            InitializeData() {
                const updatedHomeInsurance = this.unformat(this.HomePrice) * (this.HomeInsurancePerc / 100);
                this.HomeInsurance = Accounting.formatNumber(updatedHomeInsurance);
                this.DownPaymentPercentChange(this.DownPaymentPercent);
                this.PropertyTaxesPercentChange(this.PropertyTaxesPercent);
            },
            DownPaymentChange(value) {
                let downPaymentValue = this.unformat(value);
                if (downPaymentValue > this.unformat(this.HomePrice)) {
                    downPaymentValue = this.HomePrice;
                    this.DownPayment = Accounting.formatNumber(downPaymentValue);
                } else if (downPaymentValue > this.unformat(this.maxValue)) {
                    this.DownPayment = this.maxValue;
                    downPaymentValue = this.maxValue;
                }
                this.DownPaymentPercent = this.getPercentageAmount(downPaymentValue);
            },
            DownPaymentPercentChange(value) {
                this.DownPayment = Accounting.formatNumber(this.getDollarAmount(value));
                if (this.unformat(this.DownPayment) > this.unformat(this.HomePrice)) {
                    this.DownPayment = Accounting.formatNumber(this.HomePrice);
                }
            },
            PropertyTaxesChange(value) {
                let propertyTaxesValue = this.unformat(value);
                if (propertyTaxesValue > this.unformat(this.HomePrice)) {
                    propertyTaxesValue = this.HomePrice;
                    this.PropertyTaxes = Accounting.formatNumber(propertyTaxesValue);
                } else if (propertyTaxesValue > this.unformat(this.maxValue)) {
                    this.PropertyTaxes = this.maxValue;
                    propertyTaxesValue = this.maxValue;
                }
                this.PropertyTaxesPercent = this.getPercentageAmount(propertyTaxesValue);
            },
            PropertyTaxesPercentChange(value) {
                this.PropertyTaxes = Accounting.formatNumber(this.getDollarAmount(value));
                if (this.unformat(this.PropertyTaxes) > this.unformat(this.HomePrice)) {
                    this.PropertyTaxes = Accounting.formatNumber(this.HomePrice);
                }
            },
            getDollarAmount(value) {
                let calculatedValue = this.unformat(value) / 100 * this.unformat(this.HomePrice);
                calculatedValue = calculatedValue.toFixed(2) % 1 === 0 ? Math.round(calculatedValue) : calculatedValue.toFixed(2);
                return isNaN(calculatedValue) || calculatedValue === 'Infinity' ? 0 : calculatedValue;
            },
            getPercentageAmount(value) {
                let calculatedValue = this.unformat(value) / this.unformat(this.HomePrice) * 100;
                calculatedValue = calculatedValue.toFixed(2);
                return isNaN(calculatedValue) || calculatedValue === 'Infinity' ? 0 : calculatedValue;
            },
            getOverPayVal(val) {
                this.OverpaySliderVal = val;
                this.MoExtraPayment = val;
            },
            getCashBombVal(val) {
                this.CashBombSliderVal = val;
            },
            updateTableCalculation(data, dataWithoutExtraPay) {
                this.AllTotalInterest = data.loanAllYearDetail.AllTotalInterest;
                this.AllTotalPrincipal = data.loanAllYearDetail.AllTotalPrincipal;
                this.AllTotalTaxesFees = data.loanAllYearDetail.AllTotalTaxesFees;
                this.AllTotalExtraPayments = data.loanAllYearDetail.AllTotalExtraPayments;
                const totalInterestWithoutPayment = dataWithoutExtraPay.detailWithoutExtraPay.AllTotalInterest;
                const allYear = [];
                const principalAmountByYear = [];
                const interestAmountByYear = [];
                const otherExpensesAmountByYear = [];
                const extraPaymentsByYear = [];
                const amortizationsYearList = Object.keys(data.loanAllYearDetail.amortizationsByYear);
                amortizationsYearList.forEach((year) => {
                    otherExpensesAmountByYear[year] = [];
                    allYear.push(parseInt(year, 10));
                    principalAmountByYear.push(data.loanAllYearDetail.amortizationsByYear[year].totalPrincipal);
                    interestAmountByYear.push(data.loanAllYearDetail.amortizationsByYear[year].totalInterest);
                    otherExpensesAmountByYear[year].push(data.loanAllYearDetail.amortizationsByYear[year].totalTaxesFees);
                    extraPaymentsByYear.push(data.loanAllYearDetail.amortizationsByYear[year].totalExtraPayments);
                });
                this.$set(this.AllYearDeatilsForChart, 'years', allYear);
                this.$set(this.AllYearDeatilsForChart, 'principalAmounts', principalAmountByYear);
                this.$set(this.AllYearDeatilsForChart, 'interestAmounts', interestAmountByYear);
                this.$set(this.AllYearDeatilsForChart, 'otherExpensesAmounts', otherExpensesAmountByYear);
                this.$set(this.AllYearDeatilsForChart, 'extraPayments', extraPaymentsByYear);
                const payYearValues = Object.keys(data.loanAllYearDetail.amortizationsByYear);
                const payEndYear = payYearValues[payYearValues.length - 1];
                const extraPayYearValues = Object.keys(dataWithoutExtraPay.detailWithoutExtraPay.amortizationsByYear);
                const extrapayEndYear = extraPayYearValues[extraPayYearValues.length - 1];
                const withoutExtraLastDate = new Date(dataWithoutExtraPay.detailWithoutExtraPay.amortizationsByYear[extrapayEndYear].monthsDetail[dataWithoutExtraPay.detailWithoutExtraPay.amortizationsByYear[extrapayEndYear].monthsDetail.length - 1].year, dataWithoutExtraPay.detailWithoutExtraPay.amortizationsByYear[extrapayEndYear].monthsDetail[dataWithoutExtraPay.detailWithoutExtraPay.amortizationsByYear[extrapayEndYear].monthsDetail.length - 1].month, 1);
                const withExtraLastDate = new Date(data.loanAllYearDetail.amortizationsByYear[payEndYear].monthsDetail[data.loanAllYearDetail.amortizationsByYear[payEndYear].monthsDetail.length - 1].year, data.loanAllYearDetail.amortizationsByYear[payEndYear].monthsDetail[data.loanAllYearDetail.amortizationsByYear[payEndYear].monthsDetail.length - 1].month, 1);
                const months = withoutExtraLastDate.getMonth() - withExtraLastDate.getMonth() + 12 * (withoutExtraLastDate.getFullYear() - withExtraLastDate.getFullYear());
                this.SaveYears = (months - months % 12) / 12;
                this.SaveMonths = months % 12;
                this.SaveInterest = totalInterestWithoutPayment - this.AllTotalInterest;
            },
            getPaymentFrequency(val) {
                this.PaymentFrequency = val;
            },
            getCashBombFrequency(val) {
                this.CashBombFrequency = val;
            },
            getCashBombStartDate(val) {
                this.CashBombStartDate = val;
            },
            capitalize(value) {
                if (!value) return '';

                const data = value.toString();
                return data.charAt(0).toUpperCase() + data.slice(1);
            },
            currencyFilterWithPrecision(figure) {
                return figure > 0 ? Accounting.formatNumber(figure, { precision: 2 }) : 0;
            },
        },
    };
</script>
<style src="../../assets/styles/common.scss" lang="scss"></style>
<style src="../../assets/styles/calc-advanced-filter.scss" lang="scss"></style>
<style src="./main.scss" lang="scss"></style>
